import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CounselorHelpAndSupport from "./CounselorHelpAndSupport";

const CounselorHelpAndSupportLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Help And Support" />
      <CounselorHelpAndSupport />
    </MasterLayout>
  );
};

export default CounselorHelpAndSupportLayout;
